import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Oportunidad',
  alias: ['/sistema/crm/Oportunidad/Index'],
  documento: 'crm',
  filas: ['131'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/OportunidadController.cs:29',
} satisfies RutaProd;
